import React from 'react';
import './App.css';
import { useData } from './hooks/useData';
import Dashboard from './components/Dashboard';

function App() {
  const { loading, error } = useData();

  if (loading) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Overdose Analytics Dashboard</h1>
          <p>Visual Analytics for Overdose Prevention - Indiana Counties</p>
        </header>
        <main className="App-main">
          <p>Loading data...</p>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Overdose Analytics Dashboard</h1>
          <p>Visual Analytics for Overdose Prevention - Indiana Counties</p>
        </header>
        <main className="App-main">
          <p style={{ color: 'red' }}>Error loading data: {error}</p>
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>Overdose Analytics Dashboard</h1>
        <p>Visual Analytics for Overdose Prevention - Indiana Counties</p>
      </header>
      <main className="App-main">
        <Dashboard />
      </main>
    </div>
  );
}

export default App;
